import {HttpServices} from "../Helpers";
import {EmployeeStatusesEnum} from "../enums";
import {PHP_V13_URL} from "../api/urls";

const VERSION = `${process.env.REACT_APP_VERSION_API}`;

export const GetAllSetupsEmployees = async ({
  limit,
  page,
  search,
  status = EmployeeStatusesEnum.Active.key,
  use_for = "dropdown",
  other_than,
  type,
  hierarchy_uuid,
  position_uuid,
  with_than,
  company_uuid,
  all_employee = 0,
}) => {
  const queryList = [];
  if (limit || limit === 0) queryList.push(`limit=${limit}`);
  if (page || page === 0) queryList.push(`page=${page}`);
  if (search) queryList.push(`query=${search}`);
  if (status) queryList.push(`status=${status}`);
  if (use_for) queryList.push(`use_for=${use_for}`);
  if (hierarchy_uuid) queryList.push(`hierarchy_uuid=${hierarchy_uuid}`);
  if (position_uuid) queryList.push(`position_uuid=${position_uuid}`);
  if (type) queryList.push(`type=${type}`);

  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/employees/${VERSION}/employee?${queryList.join("&")}`,
    {
      params: {with_than, other_than, all_employee},
      headers:
        (company_uuid && {
          "Accept-Company": company_uuid,
        }) ||
        undefined,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const getSetupsEmployeesById = async ({uuid}) => {
  const queryList = [];
  if (uuid) queryList.push(`uuid=${uuid}`);

  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/employees/${VERSION}/employee/view?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};
